export default {
  authenticated: false
};
